import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Error Boundary to catch and suppress EZOPEN SDK errors
 * Prevents them from reaching React's error overlay
 */
class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    // Check if this is an EZOPEN SDK error
    const errorMsg = error.message || '';
    const errorStack = error.stack || '';
    
    if (errorMsg.includes('wasmplayer') || 
        errorMsg.includes('jsPlugin') || 
        errorMsg.includes('ezopen') ||
        errorMsg.includes("reading 'width'") ||
        errorMsg.includes('Cannot read properties of null') ||
        errorStack.includes('wasmplayer') ||
        errorStack.includes('jsPlugin') ||
        errorStack.includes('ezopen')) {
      // Suppress EZOPEN errors - don't show error UI
      return { hasError: false };
    }
    
    // For other errors, show error state
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const errorMsg = error.message || '';
    const errorStack = error.stack || '';
    
    // Silently ignore EZOPEN SDK errors
    if (errorMsg.includes('wasmplayer') || 
        errorMsg.includes('jsPlugin') || 
        errorMsg.includes('ezopen') ||
        errorMsg.includes("reading 'width'") ||
        errorMsg.includes('Cannot read properties of null') ||
        errorStack.includes('wasmplayer') ||
        errorStack.includes('jsPlugin') ||
        errorStack.includes('ezopen')) {
      // Reset error state so app continues normally
      this.setState({ hasError: false });
      return;
    }
    
    // Log other errors
    console.error('Uncaught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>Something went wrong.</h1>
          <button onClick={() => this.setState({ hasError: false })}>
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
